import { Injectable, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { VendorService } from './vendor.service'
import { Vendor } from '../vendor'

@Injectable({
  providedIn: 'root',
})
export class VendorResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)
  private vendorService = inject(VendorService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public resolve(route: ActivatedRouteSnapshot): Observable<Vendor> {
    const id = route.paramMap.get('id')

    return this.vendorService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('messages.loading_failed', err)
        return EMPTY
      })
    )
  }
}
